import React, { useState, useEffect } from "react";
import axios from "axios";
//forms component
import Wilayah from "./wilayah";
import Keluarga from "./keluarga";
import PUS from "./pus";
import PUSLAINNYA from "./pus-lainnya";
import KB from "./kb";
import PK from "./pk";
import HAMILLAINNYA from "./pus-lainnya/hamil";
// import PERTANYAAN from './pertanyaan';
import Finish from "./finish";

// material-ui components
import Slide from "@material-ui/core/Slide";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import useStyles from "./styles/index";
import Swal from "sweetalert2";

import { useParams, useHistory } from "react-router-dom";
import { usePouchDB } from "../../../components/PouchDB/PouchDBProvider";
import { useSnackbar } from "notistack";
import lodashGet from "lodash/get";
import { countAge } from "./pk/validation";

export default function Form(mode) {
  const USER_KEY_PG = process.env.REACT_APP_USER_KEY_PROXY_GATEWAY;
  const db_name = localStorage.getItem("db_name");
  const remote_base = localStorage.getItem("remote_base");
  const url = remote_base + "/" + db_name;
  const url_split = remote_base ? remote_base.split("/") : "";
  const couchdb = url_split[url_split.length - 1];

  const classes = useStyles();
  const history = useHistory();
  const [forms, setForms] = useState([{ type: "wilayah" }]);
  const [formIndex, setFormIndex] = useState(0);
  const {
    user: { metadata },
    dataKK,
    dataPK,
    dataKB,
    dataBkkbn,
  } = usePouchDB();
  const [done, setDone] = useState(false);
  const [slide, setSlide] = useState({
    direction: "left",
    in: true,
    navigationMode: "next",
  });

  const [isSaved, setSaved] = useState({
    local: false,
    remote: false,
  });

  const [isSubmitting, setSubmitting] = useState({
    local: false,
    remote: false,
  });

  const { enqueueSnackbar } = useSnackbar();

  const [wilayah, setWilayah] = useState({});

  const [keluarga, setKeluarga] = useState({});

  // const [pus, setPus] = useState({})

  const [kb, setKB] = useState({});

  const [normalizeKB, setNormalizeKB] = useState({});

  const [locationUser, setLocationUser] = useState("");

  const [pk, setPK] = useState({});

  const [normalizePK, setNormalizePK] = useState({});

  const [openAlert, setOpenAlert] = React.useState(false);

  // const [pusLainnya, setPusLainnya] = useState({})
  // const [hamilPertamaLainnya, setHamilPertamaLainnya] = useState('');
  // const [pertanyaanPus, setPertanyaanPus] = useState('');
  // const [jmlHamilLainnya, setJmlHamilLainnya] = useState('');

  // const [sweet, setSweet] = useState(false);
  useEffect(() => {
    //

    if (wilayah.jumlah_keluarga) {
      const jumlah_keluarga = parseInt(wilayah.jumlah_keluarga);

      setKeluarga((keluarga) => {
        let newkeluarga = {};
        for (let i = 1; i <= jumlah_keluarga; i++) {
          const id_anggota_kel = i;
          const currKeluarga = keluarga[id_anggota_kel] || {};
          newkeluarga[id_anggota_kel] = {
            no_urutnik: i,
            ...currKeluarga,
          };
        }
        setForms([
          { type: "wilayah" },
          ...Object.keys(newkeluarga).map((key) => ({
            type: "keluarga",
            id: key,
          })),
          { type: "kb" },
          { type: "pk" },
          // { type: 'pertanyaan'},
          // { type: 'pus' },
          // { type: 'hamilLainnya'},
          // { type: 'pusLainnya' },
        ]);
        return newkeluarga;
      });
    }
  }, [wilayah.jumlah_keluarga]);

  const resetForm = () => {
    //history.push('/form')
    setSlide({
      direction: "right",
      in: false,
      navigationMode: "next",
    });
    setForms([{ type: "wilayah" }]);
    setFormIndex(0);
    setSlide({
      direction: "left",
      in: true,
      navigationMode: "next",
    });
    setWilayah({});
    setKeluarga({});
    setKB({});
    setNormalizeKB({});
    setPK({});
    setNormalizePK({});

    setDone(false);
  };

  const handleNext = () => {
    setSlide({
      direction: "right",
      in: false,
      navigationMode: "next",
    });
    setTimeout(() => {
      //
      if (formIndex == 0) {
        setFormIndex((index) => index + 1);
      } else {
        if (formIndex >= forms.length - 1) {
          setDone(true);
        } else {
          setFormIndex((index) => index + 1);
        }
      }

      setSlide({
        direction: "left",
        in: true,
        navigationMode: "next",
      });
    }, 300);
  };

  const handleBack = (param) => {
    if (param === "WAW") {
      setSlide({
        direction: "left",
        in: false,
        navigationMode: "back",
      });
      setTimeout(() => {
        setFormIndex((index) => 0);
        setSlide({
          direction: "right",
          in: true,
          navigationMode: "back",
        });
      }, 300);
    } else {
      setSlide({
        direction: "left",
        in: false,
        navigationMode: "back",
      });
      setTimeout(() => {
        setFormIndex((index) => index - 1);
        setSlide({
          direction: "right",
          in: true,
          navigationMode: "back",
        });
      }, 300);
    }
  };

  if (done) {
    return (
      <>
        <Slide direction={slide.direction} in={slide.in}>
          <div>
            <Finish
              wilayah={wilayah}
              keluarga={keluarga}
              // pus={pus}
              // pusLainnya={pusLainnya}
              kb={kb}
              normalizePK={normalizePK}
              normalizeKB={normalizeKB}
              // pertanyaanPus={pertanyaanPus}
              // hamilPertamaLainnya={hamilPertamaLainnya}
              // jmlHamilLainnya={jmlHamilLainnya}
              resetForm={resetForm}
              // pk={pk}
              // kb={kb}
            />
          </div>
        </Slide>
      </>
    );
  }

  const f = forms[formIndex];

  //
  //
  //

  //

  //
  //
  //

  const handleDraft = (target, form, indexForm) => async (e) => {
    //
    //

    if (keluarga["1"].nik && keluarga["1"].nik.length === 16) {
      console.log("ini tombol draft edit", target, form, indexForm);
      var alert = window.confirm(
        "Apakah anda yakin untuk menyimpan data sementara ke Draft ?\nAnda akan diarahkan ke Daftar Draft"
      );

      if (alert == true) {
        // setOpenAlert(true);

        // put data utama to KK
        const dataKKUtama = {
          // _id: wilayah.no_kk,
          _id: `${Date.now().toString()}${metadata.name}`,
          user_name: metadata.name,
          id_prov: parseInt(metadata.wil_provinsi.id_provinsi),
          id_prov_depdagri: parseInt(
            metadata.wil_provinsi.id_provinsi_depdagri
          ),
          id_kab: parseInt(metadata.wil_kabupaten.id_kabupaten),
          id_kab_depdagri: parseInt(
            metadata.wil_kabupaten.id_kabupaten_depdagri
          ),
          id_kec: parseInt(metadata.wil_kecamatan.id_kecamatan),
          id_kec_depdagri: parseInt(
            metadata.wil_kecamatan.id_kecamatan_depdagri
          ),
          id_kel: parseInt(metadata.wil_kelurahan.id_kelurahan),
          id_kel_depdagri: parseInt(
            metadata.wil_kelurahan.id_kelurahan_depdagri
          ),
          ...wilayah,
          id_rw: wilayah.id_rw,
          id_rt: wilayah.id_rt,
          id_rw_bkkbn: wilayah.id_rw_bkkbn,
          id_rt_bkkbn: wilayah.id_rt_bkkbn,
          location: { locationUser },
        };
        const data_nik = Object.keys(keluarga).map((_id) => {
          return {
            ...keluarga[_id],
            sts_hubungan: parseInt(keluarga[_id].sts_hubungan),
            sts_kawin: parseInt(keluarga[_id].sts_kawin),
            jns_pendidikan: parseInt(keluarga[_id].jns_pendidikan),
            jns_asuransi: parseInt(keluarga[_id].jns_asuransi),
            id_agama: parseInt(keluarga[_id].id_agama),
            id_pekerjaan: parseInt(keluarga[_id].id_pekerjaan),
            usia_kawin:
              parseInt(keluarga[_id].sts_kawin) === 1
                ? 0
                : parseInt(lodashGet(keluarga[_id], "usia_kawin", 0)),
            // sts_hubanak_ibu: parseInt(lodashGet(keluarga[_id], 'sts_hubanak_ibu', 0)),
            kd_ibukandung: parseInt(
              lodashGet(keluarga[_id], "kd_ibukandung", 0)
            ),
            umur: countAge(keluarga[_id].tgl_lahir),
            keberadaan: parseInt(lodashGet(keluarga[_id], "keberadaan", 0)),
          };
        });
        //simpan ke db local
        setSubmitting((curr) => ({ ...curr, [target]: true }));

        const data_kb = Object.values(normalizeKB);
        const data_pk = Object.values(normalizePK);
        // const pertanyaan_pus = pertanyaanPus
        // const data_pus = Object.values(pus);
        // const data_pus_lainnya = Object.values(pusLainnya);
        // const hamil_pertama_pus_lainnya = hamilPertamaLainnya
        // const jumlah_keluarga_pus_lainnya = jmlHamilLainnya

        const status_draft = "1";
        const pos_draft = form;
        const subformIndex = indexForm;
        const created = Date.now();

        let os = window.navigator.userAgent; //get Browser and Os Version
        let time = new Date()
          .toLocaleString()
          .replace(",", "")
          .replace(/:.. /, " ");
        const audit_trail = "Insert Draft From " + os + " At " + time;

        const dataBkkbnAll = {
          ...dataKKUtama,
          periode_sensus: "2025",
          status_sensus: "",
          group: "dataBkkbn",
          data_nik,
          data_kb,
          data_pk,
          // pertanyaan_pus,
          // hamil_pertama_pus_lainnya,
          // jumlah_keluarga_pus_lainnya,
          // data_pus,
          // data_pus_lainnya,
          status_draft,
          pos_draft,
          subformIndex,
          audit_trail,
          created,
        };

        try {
          let dataToSaveLocal = {
            ...dataBkkbnAll,
            status_sensus: "Tersimpan",
          };
          // console.log("dataToSaveLocal", dataToSaveLocal);

          // await dataBkkbn['remote'].put(dataBkkbnAll);
          await axios.put(
            url +
              "/" +
              dataBkkbnAll._id +
              "/_put?couchdb=" +
              couchdb +
              "&database-name=" +
              db_name +
              "&_id=" +
              dataBkkbnAll._id +
              "&idKec=" +
              metadata?.wil_kecamatan?.id_kecamatan,
            dataBkkbnAll,
            {
              // headers: { user_key: USER_KEY_PG }
              headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
            }
          );
          await dataBkkbn["local"].put(dataToSaveLocal);

          let message = `Data berhasil disimpan ke server DB`;
          enqueueSnackbar(message, { variant: "success" });

          const id = wilayah._id;

          // setSubmitting(curr => ({ ...curr, [target]: false }));
          setSaved((curr) => ({ ...curr, [target]: true }));

          //
          history.push("/list-draft");
        } catch (e) {
          await dataBkkbn["local"].put(dataBkkbnAll);
          // setSubmitting(curr => ({ ...curr, [target]: false }));
          enqueueSnackbar("Data berhasil disimpan ke Lokal", {
            variant: "success",
          });
          history.push("/list-draft");
          if (e.message.includes("The database connection is closing")) {
            window.location.href = "/login";
          }
        }
      } else {
      }
    } else {
      let message = `NIK harus dimasukkan terlebih dahulu`;
      enqueueSnackbar(message, { variant: "warning" });
    }
  };

  return (
    <Container maxWidth="md" className={classes.container}>
      <Slide direction={slide.direction} in={slide.in}>
        <div>
          {f.type === "wilayah" && (
            <Wilayah
              wilayah={wilayah}
              setWilayah={setWilayah}
              setFormIndex={setFormIndex}
              handleNext={handleNext}
              handleDraft={handleDraft}
              setForms={setForms}
              setKeluarga={setKeluarga}
            />
          )}

          {f.type === "keluarga" && (
            <Keluarga
              id={f.id}
              setFormIndex={setFormIndex}
              handleNext={handleNext}
              handleBack={handleBack}
              keluarga={keluarga}
              setKeluarga={setKeluarga}
              formIndex={formIndex}
              wilayah={wilayah}
              handleDraft={handleDraft}
              direction={slide}
            />
          )}

          {f.type === "kb" && (
            <KB
              setFormIndex={setFormIndex}
              handleNext={handleNext}
              handleBack={handleBack}
              mainSlide={slide}
              keluarga={keluarga}
              wilayah={wilayah}
              kb={kb}
              setKB={setKB}
              setNormalizeKB={setNormalizeKB}
              handleDraft={handleDraft}
            />
          )}

          {f.type === "pk" && (
            <PK
              setFormIndex={setFormIndex}
              handleNext={handleNext}
              handleBack={handleBack}
              mainSlide={slide}
              keluarga={keluarga}
              wilayah={wilayah}
              kb={kb}
              pk={pk}
              setPK={setPK}
              setNormalizePK={setNormalizePK}
              handleDraft={handleDraft}
              direction={slide}
            />
          )}

          {/* {
                    f.type === 'pertanyaan' &&

                    <PERTANYAAN
                        setFormIndex={setFormIndex}
                        handleNext={handleNext}
                        handleBack={handleBack}
                        kb={kb}
                        pertanyaanPus={pertanyaanPus}
                        setPertanyaanPus={setPertanyaanPus}
                        mainSlide={slide}
                        keluarga={keluarga}
                        formIndex={formIndex}
                        wilayah={wilayah}
                        handleDraft={handleDraft}
                        direction={slide}
                    />

                } */}

          {/* {
                    f.type === 'pus' &&
                    <PUS
                        setFormIndex={setFormIndex}
                        handleNext={handleNext}
                        handleBack={handleBack}
                        kb={kb}
                        pus={pus}
                        pertanyaanPus={pertanyaanPus}
                        setPus={setPus}
                        mainSlide={slide}
                        keluarga={keluarga}
                        formIndex={formIndex}
                        wilayah={wilayah}
                        handleDraft={handleDraft}
                        direction={slide}
                    />

                }

                {
                    f.type === 'hamilLainnya' &&

                    <HAMILLAINNYA
                        setFormIndex={setFormIndex}
                        handleNext={handleNext}
                        handleBack={handleBack}
                        kb={kb}
                        jmlHamilLainnya={jmlHamilLainnya}
                        setJmlHamilLainnya={setJmlHamilLainnya}
                        hamilPertamaLainnya={hamilPertamaLainnya}
                        pertanyaanPus={pertanyaanPus}
                        setHamilPertamaLainnya={setHamilPertamaLainnya}
                        mainSlide={slide}
                        keluarga={keluarga}
                        formIndex={formIndex}
                        wilayah={wilayah}
                        handleDraft={handleDraft}
                        direction={slide}
                    />

                }

                {
                    f.type === 'pusLainnya' &&

                    <PUSLAINNYA
                        setFormIndex={setFormIndex}
                        handleNext={handleNext}
                        handleBack={handleBack}
                        kb={kb}
                        pusLainnya={pusLainnya}
                        hamilPertamaLainnya={hamilPertamaLainnya}
                        jmlHamilLainnya={jmlHamilLainnya}
                        pertanyaanPus={pertanyaanPus}
                        setPusLainnya={setPusLainnya}
                        mainSlide={slide}
                        keluarga={keluarga}
                        formIndex={formIndex}
                        wilayah={wilayah}
                        handleDraft={handleDraft}
                        direction={slide}
                    />

                } */}
        </div>
      </Slide>
    </Container>
  );
}
